export class ApiFeature {
  constructor(
    public one: string,
    public many?: string
  ) {}
}
